<ng-container>
  <ng-template *ngTemplateOutlet="template ? template : fileItem; context: {file: files}">
  </ng-template>
</ng-container>
<ng-template #fileItem>
  <div class="file-item scroll-list-send" [ngClass]="attachmentArr.length > 0 ? 'mt-2' : ''">
    <div *ngFor="let attach of attachmentArr" class="d-flex align-items-center " (click)="clickFile(attach, $event); viewImage(); currentImage(attach)">
      <div class="file-item-remove fa fa-times" (click)="removeFile(attach)"></div>
      <img *ngIf="_fileIsImage(attach)" [src]="attach.url " class="file-item__image_type hover-shadow cursor">
      <img *ngIf="!_fileIsImage(attach)" [src]="attach.name | fileIcon" class="file-item__image_type">
      <!--            <div class="file-item__name"><a href="javasript:;">{{attach.name}}</a></div>-->
    </div>
  </div>
  <i *ngIf="removable && attachmentArr.length > 0" (click)="removeAllFile(files)" class="fa fa-times file-item__remove"></i>
</ng-template>

<div *ngIf="loadImage" class="view-image p-0">
  <div *ngIf="loadImage" class="load-image-close fa fa-times" (click)="viewImage()"></div>
  <div class="load-image-content p-0">
    <a class="prev" (click)="prev(attachmentArr, imageShow)">&#10094;</a>
    <div class="d-flex justify-content-center align-items-center image-show">
      <img *ngIf="_fileIsImage(imageShow)" [src]="imageShow.url" class="mw-100 mh-100">
      <img *ngIf="!_fileIsImage(imageShow)" [src]="imageShow.name | fileIcon" class="mw-100 mh-100">
    </div>
    <a class="next" (click)="next(attachmentArr, imageShow)">&#10095;</a>
    <div class="list-item-image-select mt-2 scroll-list-send d-flex p-0 ">
      <div *ngFor="let attach of attachmentArr" (click)="currentImage(attach)" [ngClass]="attach === imageShow ? 'images-active' : 'images-none'">
        <img *ngIf="_fileIsImage(attach)" [src]="attach.url " class="file-item__image_type hover-shadow cursor" >
        <img *ngIf="!_fileIsImage(attach)" [src]="attach.name | fileIcon" class="file-item__image_type" >
      </div>
    </div>
  </div>
</div>
